import React, { useEffect, useRef, useState } from "react";
import { TextField, MenuItem, Select, InputLabel, FormControl, Button, Grid, Box, Container, Autocomplete, TextareaAutosize, Paper } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/Reduxstore";
import { getCountryAssetMasterDataList, getCountryByProjectId, getFamilyAssetMasterDataList, getIndentsTemplateDataList, getLocalStoreMasterDataList, getProjectMasterDataList, getTemplateList, getUsersByCountryId } from "../api/Services/masterServie";
import { setLoading } from "../store/CommonSlice";
import { CustomMessage } from "../const/Spinner";
import { enqueueSnackbar } from "notistack";
import { FormValues, IndentData, IndentFormData, ProjectMaster, Row, Section } from "../types/assetTypes";
import { DropdownChangeEvent } from "primereact/dropdown";
import { createIndent, getExtAssetLocalCodesByFamilyId, getIndentByIdData, getIndentTemplateByIdData, getIntAssetLocalCodesByFamilyId, getToolsAssetLocalCodesByFamilyId, getUniqueAssetNamesByFamilyId, getUniqueExtAssetNamesByFamilyId, getUniqueIntAssetNamesByFamilyId, getUniqueToolsAssetNamesByFamilyId, handleExternalAsset, handleInternalAsset, handleToolAsset, updateIndent } from "../api/Services/assetServices";
import { PAGESTART, PAGESEND } from "../api/endpoint";
import { getListOfStock, getStockCodesByCategory } from "../api/Services/stockService";

type StockOption = {
  label: string;
  value: string;
  name: {
    stockCode: string;
    stock_description: string;
    currentStock: number;
  };
};

const mapStockOptions = (items: any[] = []): StockOption[] =>
  items.map((item) => ({
    label: `${item.stock_code} - ${item.stock_description || ""}`,
    value: item.stockCodeId.toString(),
    name: {
      stockCode: item.stock_code,
      stock_description: item.stock_description ?? "",
      currentStock: item.current_stock ?? 0,
    },
  }));

type AssetLocalOption = {
  assetName: string;
  localCode: string;
};

const mapAssetLocalOptions = (items: any[] = []): AssetLocalOption[] =>
  items.map((item) => ({
    assetName: item.assetName ?? "",
    localCode: item.localCode ?? "",
  }));

const tableAutocompleteSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    minHeight: "35px",
    padding: "0 8px",
  },
  "& .MuiAutocomplete-input": {
    padding: "0 !important",
  },
};

interface CreatetTemplateProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  indentId: number | null;
  setIndentId: React.Dispatch<React.SetStateAction<number | null>>;
  userId: number;
  setSelectedStage: React.Dispatch<React.SetStateAction<string>>;
  indentPrimaryId: number | null;
  setIndentPrimaryId: React.Dispatch<React.SetStateAction<number | null>>;
  setSubmittedPayload: React.Dispatch<React.SetStateAction<IndentFormData | null>>;
  submittedPayload: IndentFormData | null;
  setEditOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  editData?: IndentData;

}

const CreatingIndentStageThree: React.FC<CreatetTemplateProps> = ({ setOpen, indentId, setEditOpen, editData,
  setIndentId, userId, indentPrimaryId, setIndentPrimaryId, setSubmittedPayload, submittedPayload, setSelectedStage }) => {
  const userDetails = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const getAssetLocalOptions = async (
    familyAssetId: number,
    sectionTitle: string
  ): Promise<AssetLocalOption[]> => {
    const response =
      sectionTitle === "Tools (internal)"
        ? await getToolsAssetLocalCodesByFamilyId(familyAssetId)
        : sectionTitle === "Main (external)"
        ? await getExtAssetLocalCodesByFamilyId(familyAssetId)
        : await getIntAssetLocalCodesByFamilyId(familyAssetId);

    return response?.status?.code === 200 && Array.isArray(response.data)
      ? mapAssetLocalOptions(response.data)
      : [];
  };
    interface AssetOption {
    label: string;
    value: string;
  }



  console.log("IndentPrimaryId:", indentPrimaryId);
  useEffect(() => {
    if (submittedPayload?.currentLocationId) {
      console.log("Fetching users for submitted payload location:", submittedPayload.currentLocationId);
      getUsers(submittedPayload.currentLocationId);
    }
    if (submittedPayload?.requestFromId) {
      console.log("Fetching countries for submitted payload requestFromId:", submittedPayload.requestFromId);
      getCountryNamesList(PAGESTART, PAGESEND);
    }

    // if (submittedPayload?.indentTemplateId){
    //  getDataById(submittedPayload.indentTemplateId)

    // }
  }, [submittedPayload]);

  console.log("datain stage 3:", submittedPayload);

  const [formData, setFormData] = useState<IndentFormData>(() => ({
    indentId: editData?.indentId ?? submittedPayload?.indentId ?? 0,
    userId: editData?.userId ?? userDetails?.userId ?? 0,
    username: userDetails?.name ?? "",
    indentNo: editData?.indentNo ?? submittedPayload?.indentNo ?? 0,
    countryName: editData?.countryName ?? submittedPayload?.countryName ?? "",
    currentLocationId: editData?.currentLocationId ?? submittedPayload?.currentLocationId ?? 0,
    indentPrimaryId: editData?.indentPrimaryId ?? submittedPayload?.indentPrimaryId ?? (indentPrimaryId ?? 0),
    requestTo: editData?.requestTo ?? submittedPayload?.requestTo ?? "",
    requestToId: editData?.requestToId ?? submittedPayload?.requestToId ?? 0,
    requestFromId: Number(editData?.requestFromId ?? submittedPayload?.requestFromId ?? 0),
    requestFrom: editData?.requestFrom ?? submittedPayload?.requestFrom ?? "",
    address: editData?.address ?? submittedPayload?.address ?? "",
    mapLocation: editData?.mapLocation ?? submittedPayload?.mapLocation ?? "",
    date: editData?.date ?? submittedPayload?.date ?? "",
    defaultList: editData?.defaultList ?? submittedPayload?.defaultList ?? "",
    notify: editData?.notify ?? submittedPayload?.notify ?? "",
    notes: editData?.notes ?? submittedPayload?.notes ?? "",
    //indentTemplateId: editData?.indentTemplateId ?? submittedPayload?.indentTemplateId ?? 0,
    // indentTemplateName: editData?.indentTemplateName ?? submittedPayload?.indentTemplateName ?? "",
    status: editData?.status ?? submittedPayload?.status ?? 0, // ✅ priority to backend editData
    userIds: submittedPayload?.userIds ?? [],
    section: (editData?.section ?? submittedPayload?.section ?? []).map((sec) => ({
      title: sec.title,
      rows: sec.rows.map((row) => ({
        familyAssetId: Number(row.familyAssetId ?? 0),
        familyName: row.familyName ?? "",
        assetName: row.assetName ?? "",
        description: row.description ?? "",
        localStoreId: Number(row.localStoreId ?? 0),
        localStore: row.localStore ?? "",
        comment: row.comment ?? "",
        qty: row.qty ?? 0,
        dateReqd: row.dateReqd ?? null,
        stockCodeId: row.stockCodeId ?? undefined,
        stockCode: row.stockCode ?? undefined,
        stockDescription: row.stockDescription ?? undefined,
        currentStock: row.currentStock ?? undefined,
        issued: row.issued ?? undefined,
        pending: row.pending ?? undefined,
        stockCategory: row.stockCategory ?? undefined,
      })),
    })),
  }));



  // const [formData, setFormData] = useState<IndentFormData>({
  //   indentId: submittedPayload?.indentId ?? 0,
  //   userId: userDetails?.userId ?? 0,
  //   username: userDetails?.name ?? "",
  //   indentNo: submittedPayload?.indentNo ?? 0,
  //   countryName: submittedPayload?.countryName ?? "",
  //   currentLocationId: submittedPayload?.currentLocationId ?? 0,
  //   indentPrimaryId: submittedPayload?.indentPrimaryId ?? (indentPrimaryId ?? 0),
  //   requestTo: submittedPayload?.requestTo ?? "",
  //   requestToId: submittedPayload?.requestToId ?? 0,
  //   requestFromId: Number(submittedPayload?.requestFromId ?? 0),
  //   requestFrom: submittedPayload?.requestFrom ?? "",
  //   address: submittedPayload?.address ?? "",
  //   mapLocation: submittedPayload?.mapLocation ?? "",
  //   date: submittedPayload?.date ?? "",
  //   defaultList: submittedPayload?.defaultList ?? "",
  //   notify: submittedPayload?.notify ?? "",
  //   notes: submittedPayload?.notes ?? "",
  //   indentTemplateId: submittedPayload?.indentTemplateId ?? 0,
  //   indentTemplateName: submittedPayload?.indentTemplateName ?? "",
  //   status: submittedPayload?.status ?? 0,
  //   userIds: submittedPayload?.userIds ?? [],
  //   section: submittedPayload?.section?.map((sec) => ({
  //     title: sec.title,
  //     rows: sec.rows.map((row) => ({
  //       familyAssetId: Number(row.familyAssetId ?? 0),
  //       familyName: row.familyName ?? "",
  //       assetName: row.assetName ?? "",
  //       description: row.description ?? "",
  //       localStoreId: Number(row.localStoreId ?? 0),
  //       localStore: row.localStore ?? "",
  //       comment: row.comment ?? "",
  //       qty: row.qty ?? 0,
  //       dateReqd: row.dateReqd ?? null,
  //       stockCodeId: row.stockCodeId ?? undefined,
  //       stockCode: row.stockCode ?? undefined,
  //       stockDescription: row.stockDescription ?? undefined,
  //       currentStock: row.currentStock ?? undefined,
  //       issued: row.issued ?? undefined,
  //       pending: row.pending ?? undefined,
  //       stockCategory: row.stockCategory ?? undefined,
  //     })),
  //   })) ?? [],
  // });
  useEffect(() => {
    const sourceSections = editData?.section ?? submittedPayload?.section;
    if (!sourceSections || sourceSections.length === 0) return;

    const fetchAssetOptionsForPayload = async () => {
      const updatedSections = await Promise.all(
        sourceSections.map(async (sec) => {
          const updatedRows = await Promise.all(
            sec.rows.map(async (row) => {
              let enrichedRow: Row = { ...row };

              if (row.stockCategory && row.stockCategory.trim() !== "") {
                const stockResponse = await getStockCodesByCategory(row.stockCategory);
                const stockOptions = mapStockOptions(stockResponse.data);
                const selectedStock = stockOptions.find(
                  (item) => Number(item.value) === Number(row.stockCodeId)
                );

                enrichedRow = {
                  ...enrichedRow,
                  stockOptions,
                  stockCodeId: selectedStock?.value ?? row.stockCodeId,
                  stockCode: selectedStock?.name.stockCode ?? row.stockCode ?? "",
                  stockDescription: selectedStock?.name.stock_description ?? row.stockDescription ?? "",
                  currentStock: selectedStock?.name.currentStock ?? row.currentStock ?? 0,
                };
              }

              if (row.familyAssetId && row.familyAssetId > 0) {
                const assetOptions = await getAssetLocalOptions(Number(row.familyAssetId), sec.title);
                const selectedAsset = assetOptions.find(
                  (item) => item.assetName === row.assetName || item.localCode === row.description
                );

                return {
                  ...enrichedRow,
                  assetName: selectedAsset?.assetName ?? row.assetName ?? "",
                  description: selectedAsset?.localCode ?? row.description ?? "",
                  availableAssets: assetOptions,
                };
              }
              return enrichedRow;
            })
          );

          return {
            ...sec,
            rows: updatedRows,
          };
        })
      );

      // ✅ Update formData with submittedPayload + populated asset options
      const sourceData = editData ?? submittedPayload;

      setFormData((prev): IndentFormData => ({
        ...prev,
        ...(sourceData ?? {}),

        countryName: sourceData?.countryName ?? "",
        requestTo: sourceData?.requestTo ?? "",
        requestFrom: sourceData?.requestFrom ?? "",
        username: sourceData?.username ?? prev.username ?? "",
        address: sourceData?.address ?? "",
        mapLocation: sourceData?.mapLocation ?? "",
        date: sourceData?.date ?? "",
        defaultList: sourceData?.defaultList ?? "",
        notify: sourceData?.notify ?? "",
        notes: sourceData?.notes ?? "",

        section: updatedSections,
      }));
      setData(updatedSections);
    };

    fetchAssetOptionsForPayload();
  }, [submittedPayload, editData]);

  const [categories, setCategories] = useState<
    { label: string; value: string | null }[]
  >([
    { label: "Electrical", value: "electrical" },
    { label: "Rubber", value: "rubber" },
  ]);






  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle select change for select fields
  const handleSelectChange = (
    e: SelectChangeEvent<string>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const [fromCountryName, setFromCountryName] = useState<
    { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (fromCountryName.length === 0) getCountryNamesList(PAGESTART, PAGESEND);
  }, [fromCountryName]);





  const [requestproject, setRequestProjects] = useState<
    { label: string; value: string | null }[]
  >([]);
  const [project, setProjects] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [users, setusers] = useState<
    { label: string; value: number }[]
  >([]);

  const [intAssets, setIntAssets] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [extAssets, setExtAssets] = useState<
    { label: string; value: string | null }[]
  >([]);





  useEffect(() => {
    if (project.length === 0) getProjectList(1, PAGESEND);
  }, [project]);

  useEffect(() => {
    if (requestproject.length === 0) getRequestProjectList(1, PAGESEND);
  }, [requestproject]);


  const getProjectList = async (page: number, rows: number) => {

    try {
      const { data, status } = await getProjectMasterDataList(page, rows, { requestFromId: { value: "", matchMode: "startsWith" } });
      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.projectId.toString(),
          label: val.projectName,
        }));
        updatedData.unshift({ label: "--Select--", value: "" });
        setProjects(updatedData);

      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };
  const getAssetNameList = async (
    familyAssetId: number
  ): Promise<{ label: string; value: string }[]> => {
    console.log("Fetching asset names for familyAssetId:", familyAssetId);


    try {
      const { data, status } = await getUniqueAssetNamesByFamilyId(familyAssetId);
      console.log("API Response:", { data, status });

      if (status.code === 200 && Array.isArray(data) && data.length > 0) {
        console.log("Raw assetName data:", data);

        const updatedData: { label: string; value: string }[] = data.map(
          (assetName: string) => ({
            value: assetName,
            label: assetName,
          })
        );
        updatedData.unshift({ label: "--Select--", value: "" });

        console.log("Processed Asset Name List:", updatedData);

        setAssets(updatedData);
        return updatedData; // ✅ return
      }
    } catch (error: any) {
      console.error("Error fetching asset names:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Loading state set to false");
    }

    // ✅ fallback return (never undefined)
    return [{ label: "--Select--", value: "" }];
  };

  const getExtAssetNameList = async (
    familyAssetId: number
  ): Promise<{ label: string; value: string }[]> => {
    console.log("Fetching asset names for familyAssetId:", familyAssetId);


    try {
      const { data, status } = await getUniqueExtAssetNamesByFamilyId(familyAssetId);
      console.log("API Response:", { data, status });

      if (status.code === 200 && Array.isArray(data) && data.length > 0) {
        console.log("Raw assetName data:", data);

        const updatedData: { label: string; value: string }[] = data.map(
          (assetName: string) => ({
            value: assetName,
            label: assetName,
          })
        );
        updatedData.unshift({ label: "--Select--", value: "" });

        console.log("Processed Asset Name List:", updatedData);

        setExtAssets(updatedData);
        return updatedData; // ✅ return
      }
    } catch (error: any) {
      console.error("Error fetching asset names:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Loading state set to false");
    }

    // ✅ fallback return
    return [{ label: "--Select--", value: "" }];
  };

  const getToolAssetNameList = async (
    familyAssetId: number
  ): Promise<{ label: string; value: string }[]> => {
    console.log("Fetching asset names for familyAssetId:", familyAssetId);


    try {
      const { data, status } = await getUniqueToolsAssetNamesByFamilyId(familyAssetId);
      console.log("API Response:", { data, status });

      if (status.code === 200 && Array.isArray(data) && data.length > 0) {
        console.log("Raw assetName data:", data);

        const updatedData: { label: string; value: string }[] = data.map(
          (assetName: string) => ({
            value: assetName,
            label: assetName,
          })
        );
        updatedData.unshift({ label: "--Select--", value: "" });

        console.log("Processed Asset Name List:", updatedData);

        setExtAssets(updatedData);
        return updatedData; // ✅ return
      }
    } catch (error: any) {
      console.error("Error fetching asset names:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Loading state set to false");
    }

    // ✅ fallback return
    return [{ label: "--Select--", value: "" }];
  };


  const getIntAssetNameList = async (
    familyAssetId: number
  ): Promise<{ label: string; value: string }[]> => {
    console.log("Fetching asset names for familyAssetId:", familyAssetId);


    try {
      const { data, status } = await getUniqueIntAssetNamesByFamilyId(familyAssetId);
      console.log("API Response:", { data, status });

      if (status.code === 200 && Array.isArray(data) && data.length > 0) {
        const updatedData: { label: string; value: string }[] = data.map(
          (assetName: string) => ({
            value: assetName,
            label: assetName,
          })
        );
        updatedData.unshift({ label: "--Select--", value: "" });

        setIntAssets(updatedData);
        return updatedData; // ✅ always return array
      }
    } catch (error: any) {
      console.error("Error fetching asset names:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Loading state set to false");
    }

    // ✅ fallback return so TS never sees undefined
    return [{ label: "--Select--", value: "" }];
  };
  const getRequestProjectList = async (page: number, rows: number) => {

    try {
      const { data, status } = await getProjectMasterDataList(page, rows, { requestFromId: { value: "", matchMode: "startsWith" } });
      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.projectId.toString(),
          label: val.projectName,
        }));
        updatedData.unshift({ label: "--Select--", value: "" });
        setRequestProjects(updatedData);

      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const getUsers = async (currentLocationId: number) => {
    try {
      const { data, status } = await getUsersByCountryId(currentLocationId);

      if (status.code === 200 && data?.length > 0) {
        const updatedUsers: { label: string; value: number }[] = data.map(
          (val: { user_id: number; name: string }) => ({
            value: val.user_id,
            label: val.name ?? "",
          })
        );

        updatedUsers.unshift({ label: "--Select--", value: 0 });
        setusers(updatedUsers); // ✅ only set users
      } else {
        setusers([]); // ✅ set empty if none
      }
    } catch (error: any) {
      setusers([]);
      CustomMessage(error?.message || "Failed to fetch users", "error", enqueueSnackbar);
    }
  };




  const handleSelectFromCountryChange = (

    _event: any,
    newValue: { label: string; value: string | null } | null
  ) => {
    if (!newValue || !newValue.value) return;

    const updatedData: Partial<IndentFormData> = { ...formData };

    updatedData.countryName = newValue.label;
    updatedData.currentLocationId = parseInt(newValue.value);

    console.log("info:", updatedData);

    setFormData(updatedData as IndentFormData);
    getUsers(parseInt(newValue.value)); // ✅ fix here

  };


  const getCountryNamesList = async (page: number, rows: number) => {

    try {
      const { data, status } = await getCountryAssetMasterDataList(
        page,
        rows,
        { currentLocationId: { value: "", matchMode: "startsWith" } }
      );
      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map(
          (val: { currentLocationId: number | string; countryName: string }) => ({
            value: String(val.currentLocationId),
            label: val.countryName ?? "",
          })
        );

        updatedData.unshift({ label: "--Select--", value: null }); // Support null value
        setFromCountryName(updatedData);

      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };


  // Define constants

  const [families, setfamilies] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [toolsfamilies, settoolsfamilies] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [suppliers, setSuppliers] = useState<
    { label: string; value: string | null }[]
  >([]);

  const [assets, setAssets] = useState<
    { label: string; value: string | null }[]
  >([]);



  useEffect(() => {
    if (families.length === 0) getAssetTypeList(1, PAGESEND);
  }, [families]);
  useEffect(() => {
    if (toolsfamilies.length === 0) getToolsFamiliesList(1, PAGESEND);
  }, [toolsfamilies]);

  useEffect(() => {
    if (suppliers.length === 0) getLocalStoreList(1, PAGESEND);
  }, [suppliers]);

  const getAssetTypeList = async (page: number, rows: number) => {

    console.log("Fetching asset types...");

    try {
      const { data, status } = await getFamilyAssetMasterDataList(page, rows, {
        familyAssetId: { value: "", matchMode: "startsWith" }
      });

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.familyAssetId.toString(),
          label: val.familyName,
        }));

        updatedData.unshift({ label: "--Select--", value: null });


        console.log("Updated asset type list:", updatedData);

        setfamilies(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };

  useEffect(() => {
    if (suppliers.length === 0) getLocalStoreList(1, PAGESEND);
  }, [suppliers]);

  const getLocalStoreList = async (page: number, rows: number) => {

    console.log("Fetching asset types...");

    try {
      const { data, status } = await getLocalStoreMasterDataList(page, rows, {
        familyAssetId: { value: "", matchMode: "startsWith" }
      });

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.localStoreId.toString(),
          label: val.localStore
        }));

        updatedData.unshift({ label: "--Select--", value: null });


        console.log("Updated asset type list:", updatedData);

        setSuppliers(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };



  const [internalfamilies, setinternalfamilies] = useState<
    { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (internalfamilies.length === 0) getInternalAssetTypeList(1, PAGESEND);
  }, [internalfamilies]);

  const getInternalAssetTypeList = async (page: number, rows: number) => {

    console.log("Fetching asset types...");

    try {
      const { data, status } = await handleInternalAsset();

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.familyAssetId.toString(),
          label: val.familyName,
        }));

        updatedData.unshift({ label: "--Select--", value: null });


        console.log("Updated asset type list:", updatedData);

        setinternalfamilies(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };

  const [externalfamilies, setexternalfamilies] = useState<
    { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (externalfamilies.length === 0) getExternalAssetTypeList(1, PAGESEND);
  }, [externalfamilies]);

  const getExternalAssetTypeList = async (page: number, rows: number) => {

    console.log("Fetching asset types...");

    try {
      const { data, status } = await handleExternalAsset();

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.familyAssetId.toString(),
          label: val.familyName,
        }));

        updatedData.unshift({ label: "--Select--", value: null });


        console.log("Updated asset type list:", updatedData);

        setexternalfamilies(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };

  const getToolsFamiliesList = async (page: number, rows: number) => {

    console.log("Fetching asset types...");

    try {
      const { data, status } = await handleToolAsset();

      console.log("Asset type response:", data, status);

      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map((val) => ({
          value: val.familyAssetId.toString(),
          label: val.familyName,
        }));

        updatedData.unshift({ label: "--Select--", value: null });


        console.log("Updated asset type list:", updatedData);

        settoolsfamilies(updatedData);

      }
    } catch (error: any) {
      console.error("Error fetching asset types:", error);
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
      console.log("Asset type fetch completed.");
    }
  };

  useEffect(() => {
    console.log("Internal families updated:", internalfamilies);
  }, [internalfamilies]);

  useEffect(() => {
    console.log("External families updated:", externalfamilies);
  }, [externalfamilies]);

  useEffect(() => {
    console.log("Tools families updated:", toolsfamilies);
  }, [toolsfamilies]);

  const sections: Section[] = [
    { title: 'Main (internal)', rows: [] },
    { title: 'Main (external)', rows: [] },
    { title: 'Tools (internal)', rows: [] },
    { title: 'Stores Consumables', rows: [] },
    { title: 'General Consumables', rows: [] },
  ];
  const [data, setData] = useState<Section[]>(sections);
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [selectedSectionIdx, setSelectedSectionIdx] = useState<number | null>(null);

  // Ensure at least one row is present on initial load
  useEffect(() => {
    const updatedData = data.map((section) => ({
      ...section,
      rows: section.rows.length > 0 ? section.rows : [
        {
          familyAssetId: 0,
          familyName: "",
          assetName: '',
          description: '',
          localStoreId: 0,
          localStore: "",
          comment: '', issued: 0, pending: 0,
          qty: 0,
          dateReqd: null,
          stockCategory: "",
        }
      ],
    }));
    setData(updatedData);
  }, []);

  const handleAddRow = (sectionIndex: number) => {
    const newRow: Row = {
      familyAssetId: 0,
      familyName: "",
      assetName: '',
      description: '',
      localStoreId: 0,
      localStore: "", issued: 0, pending: 0,
      comment: '',
      qty: 0,
      stockCategory: "",

      dateReqd: null,
    };
    const updated = [...data];
    updated[sectionIndex].rows.push(newRow);
    setData(updated);
  };



  const handleSelectFamilyChange = async (
    sectionIndex: number,
    rowIndex: number,
    selectedValue: string,
    sectionTitle: string
  ) => {
    const familyList =
      sectionTitle === "Main (internal)"
        ? internalfamilies
        : sectionTitle === "Main (external)"
          ? externalfamilies
          : sectionTitle === "Tools (internal)"
            ? toolsfamilies
            : families;

    const selectedFamily = familyList.find(fam => String(fam.value) === selectedValue);

    if (!selectedFamily) return;

    const familyName = selectedFamily.label;
    const familyAssetId = Number(selectedFamily.value);

    // Update family info in row
    handleChange(sectionIndex, rowIndex, "familyName", familyName);
    handleChange(sectionIndex, rowIndex, "familyAssetId", familyAssetId);

    // Fetch assets for this row only
    let assetOptions: AssetLocalOption[] = [];

    try {
      assetOptions = await getAssetLocalOptions(familyAssetId, sectionTitle);
    } catch (error) {
      console.error("Error fetching asset names:", error);
    }

    // Store asset options only in this row
    setData((prev) => {
      const updatedSections = [...prev];
      const updatedRows = [...updatedSections[sectionIndex].rows];

      updatedRows[rowIndex] = {
        ...updatedRows[rowIndex],
        assetName: "",
        description: "",
        availableAssets: assetOptions,
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        rows: updatedRows,
      };

      return updatedSections;
    });
  };


  const handleLocalStoreChange = (sectionIndex: number, rowIndex: number, selectedIndex: number) => {
    const selectedStore = suppliers[selectedIndex];

    const localStore: string = selectedStore.label ?? '';
    const localStoreIdStr: string = selectedStore.value?.toString() ?? '';

    // Call handleChange to update as string
    handleChange(sectionIndex, rowIndex, 'localStore', localStore);
    handleChange(sectionIndex, rowIndex, 'localStoreId', localStoreIdStr);

    // Convert to number safely and pass to getAssetNameList

  };

  const handleAssetName = (
    sectionIndex: number,
    rowIndex: number,
    field: keyof Row,
    selectedValue: string
  ) => {
    const selectedAsset = assets.find(a => a.value?.toString() === selectedValue);

    const assetName: string = selectedAsset?.label ?? '';


    // Save the value (for the select input) and the label (as assetName)

    handleChange(sectionIndex, rowIndex, 'assetName', assetName);
  };
  const handleChange = (
    sectionIndex: number,
    rowIndex: number,
    field: keyof Row,
    value: any
  ) => {
    setData((prevData) => {
      const updatedData = [...prevData]; // shallow copy of sections
      const updatedSection = { ...updatedData[sectionIndex] }; // copy of one section
      const updatedRows = [...updatedSection.rows]; // copy of rows
      const updatedRow = { ...updatedRows[rowIndex], [field]: value }; // copy and update one row

      // 🔹 Auto calculate pending if qty or issued changes
      if (field === "qty" || field === "issued") {
        const qty = Number(field === "qty" ? value : updatedRow.qty) || 0;
        const issued = Number(field === "issued" ? value : updatedRow.issued) || 0;

        // ✅ If issued not entered (0 or empty), pending = qty
        // ✅ Else pending = qty - issued, but not negative
        updatedRow.pending = issued ? Math.max(0, qty - issued) : qty;
      }

      updatedRows[rowIndex] = updatedRow;
      updatedSection.rows = updatedRows;
      updatedData[sectionIndex] = updatedSection;

      return updatedData;
    });
  };

  const updateRow = (
    sectionIndex: number,
    rowIndex: number,
    updater: (row: Row) => Row
  ) => {
    setData((prevData) => {
      const updatedData = [...prevData];
      const updatedSection = { ...updatedData[sectionIndex] };
      const updatedRows = [...updatedSection.rows];
      updatedRows[rowIndex] = updater(updatedRows[rowIndex]);
      updatedSection.rows = updatedRows;
      updatedData[sectionIndex] = updatedSection;
      return updatedData;
    });
  };


  //   const handleDeleteRow = (sectionIndex: number, rowIndex: number) => {
  //     const updated = [...data];
  //     updated[sectionIndex].rows.splice(rowIndex, 1);
  //     setData(updated);
  //   };

  const handleSubmit = async (status: number, stage: number) => {
    const finalData: IndentFormData = {
      ...formData,
      section: data,
      status: status,
      stage: stage,
      indentPrimaryId: indentPrimaryId ?? 0,
    };



    try {
      let response;

      // Create or update based on indentId
      if (!finalData.indentId || finalData.indentId === 0) {
        response = await createIndent(finalData);
      } else {
        response = await updateIndent(finalData);
      }

      const statusCode = response.status;
      const statusMessage = response.data?.status?.message;

      if (statusCode === 201 || statusCode === 200) {
        // CustomMessage(statusMessage || "Success", "success", enqueueSnackbar);
        const indentPrimaryId = response.data?.data?.indentPrimaryId;
        console.log("Returned indentPrimaryId:", indentPrimaryId); // ✅ Log added here
        if (indentPrimaryId) {
          setIndentPrimaryId(indentPrimaryId);
        }
        setSelectedStage("stage1");
        setOpen(false);
        setEditOpen?.(false);
      } else {
        CustomMessage("Failed to save indent", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message || "Something went wrong", "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };



  const handleCancel = async () => {
    setOpen(false);
    setEditOpen?.(false);
  };




  const handleScrollTo = (idx: number) => {
    setSelectedSectionIdx(idx);
    sectionRefs.current[idx]?.scrollIntoView({ behavior: 'smooth' });
  };

  const blankRow: Row = {
    familyAssetId: 0,
    familyName: '',
    assetName: '',
    localStoreId: 0,
    localStore: '',
    description: '', issued: 0, pending: 0,
    stockCategory: "",

    comment: '',
    qty: 0,
    dateReqd: null,
  };

  useEffect(() => {
    // Initialize the first section (Main internal) to be selected on initial load
    setSelectedSectionIdx(0);

    const updatedData = data.map((section) => ({
      ...section,
      rows: section.rows.length > 0 ? section.rows : [blankRow],
    }));
    setData(updatedData);
  }, []);


  const handleSelectProjectChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof any,
    name2: keyof any
  ) => {
    const updatedData: Partial<IndentFormData> = { ...formData };

    (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
    (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;


    setFormData(updatedData as IndentFormData);



  };

  const handleSelectRequestProjectChange = (
    e: DropdownChangeEvent | React.ChangeEvent<HTMLInputElement> | any,
    name: keyof any,
    name2: keyof any
  ) => {
    const updatedData: Partial<IndentFormData> = { ...formData };

    (updatedData as any)[name] = (e.target as { value: { label: string } }).value?.label || "";
    (updatedData as any)[name2] = (e.target as { value: { value: number } }).value?.value || 0;


    setFormData(updatedData as IndentFormData);


  };

  const handleDeleteRow = (sectionIndex: number, rowIndex: number) => {
    const updated = [...data];
    updated[sectionIndex].rows.splice(rowIndex, 1); // Remove the row
    setData(updated);
  };

  const handleSelectFromUserChange = (
    _event: any,
    newValue: { label: string; value: number }[]
  ) => {
    const updatedUserIds = newValue.map((val) => val.value);

    setFormData((prev) => ({
      ...prev,
      userIds: updatedUserIds,
    }));
  };

  const [defaultLists, setDefaultLists] = useState<
    { label: string; value: string | null }[]
  >([]);

  useEffect(() => {
    if (defaultLists.length === 0) getTemplateList(PAGESTART, PAGESEND);
  }, [defaultLists]);

  const selectedTemplateOption = defaultLists.find(
    (option) => option.label === formData.indentTemplateName
  ) || null;
  const [indentTemplateId, setIndentTemplateId] = useState<number | null>(null);

  const getDataById = async (templateId: number) => {
    if (!templateId) return;
    setLoading(true);

    try {
      const response = await getIndentTemplateByIdData(templateId);
      console.log("API Response:", response.data);

      if (response.data) {
        const { section, ...otherIndentData } = response.data;
        let updatedSections = section || [];

        // 🔹 Handle asset fetching for internal/external/tools
        for (let sIdx = 0; sIdx < updatedSections.length; sIdx++) {
          const sec = updatedSections[sIdx];

          for (let rIdx = 0; rIdx < sec.rows.length; rIdx++) {
            const row = sec.rows[rIdx];

            // 🔸 If section has stockCategory — trigger onFetchData
            if (row.stockCategory && row.stockCategory.trim() !== "") {
              const stockResponse = await getStockCodesByCategory(row.stockCategory);
              const stockOptions = mapStockOptions(stockResponse.data);
              const selectedStock = stockOptions.find(
                (item) => Number(item.value) === Number(row.stockCodeId)
              );

              updatedSections[sIdx].rows[rIdx] = {
                ...updatedSections[sIdx].rows[rIdx],
                stockOptions,
                stockCodeId: selectedStock?.value ?? row.stockCodeId,
                stockCode: selectedStock?.name.stockCode ?? row.stockCode ?? "",
                stockDescription: selectedStock?.name.stock_description ?? row.stockDescription ?? "",
                currentStock: selectedStock?.name.currentStock ?? row.currentStock ?? 0,
              };
            }

            // 🔹 If asset-based section, fetch asset name list
            if (row.familyAssetId && row.familyAssetId > 0) {
              const assetOptions = await getAssetLocalOptions(Number(row.familyAssetId), sec.title);
              const selectedAsset = assetOptions.find(
                (item) => item.assetName === row.assetName || item.localCode === row.description
              );

              updatedSections[sIdx].rows[rIdx] = {
                ...row,
                assetName: selectedAsset?.assetName ?? row.assetName ?? "",
                description: selectedAsset?.localCode ?? row.description ?? "",
                availableAssets: assetOptions,
              };
            }
          }
        }

        // ✅ Update the form and data states
        const updatedFormData = {
          ...formData,
          ...otherIndentData,
          section: updatedSections,
        };

        setFormData(updatedFormData);
        setData(updatedSections);

        console.log("✅ Final updatedSections:", updatedSections);
      }

      setIndentTemplateId(null);
    } catch (error: any) {
      console.error("❌ Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };



  const handleTemplateSelect = async (
    event: any,
    selectedOption: { label: string; value: string | null } | null
  ) => {
    if (selectedOption?.value) {
      const selectedId = Number(selectedOption.value);
      setIndentTemplateId(selectedId); // still set it for reference if needed

      // ✅ Call getDataById with the selected ID
      await getDataById(selectedId);
    }
    else {
      // Reset to default row structure
      setIndentTemplateId(null);

      const defaultRow: Row = {
        familyAssetId: 0,
        familyName: "",
        assetName: "",
        description: "",
        localStoreId: 0,
        localStore: "",
        comment: "",
        qty: 0, issued: 0, pending: 0,
        dateReqd: null, // Or "" or new Date() depending on what you're using
        stockCategory: "",
      };

      const baseSections: Section[] = [
        { title: "Main (internal)", rows: [{ ...defaultRow }] },
        { title: "Main (external)", rows: [{ ...defaultRow }] },
        { title: "Tools (internal)", rows: [{ ...defaultRow }] },
        { title: "Stores Consumables", rows: [{ ...defaultRow }] },
        { title: "General Consumables", rows: [{ ...defaultRow }] },
      ];

      setFormData((prev) => ({
        ...prev,
        indentTemplateName: "",
        section: baseSections,
      }));

      setData(baseSections);
    }
  };



  const getTemplateList = async (page: number, rows: number) => {

    try {
      const { data, status } = await getIndentsTemplateDataList(
        page,
        rows,
        { indentTemplateId: { value: "", matchMode: "startsWith" } }
      );
      if (status.code === 200 && data?.length > 0) {
        const updatedData: { label: string; value: string | null }[] = data.map(
          (val: { indentTemplateId: number | string; indentTemplateName: string }) => ({
            value: String(val.indentTemplateId),
            label: val.indentTemplateName ?? "",
          })
        );

        //updatedData.unshift({ label: "--Select--", value: null }); // Support null value
        setDefaultLists(updatedData);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  type Filters = {
    [key: string]: {
      value: string[]; // <- expects an array
    };
  };

  const [storeConsumableStockCodes, setStoreConsumableStockCodes] = useState<
    {
      label: string;
      value: string;
      name: {
        stockCode: string;
        stock_description: string;
        currentStock: number;
      };
    }[]
  >([]);

  const [generalConsumableStockCodes, setGeneralConsumableStockCodes] = useState<
    {
      label: string;
      value: string;
      name: {
        stockCode: string;
        stock_description: string;
        currentStock: number;
      };
    }[]
  >([]);

  const onFetchData = async (stockCategory: string, sectionIndex: number, rowIndex: number) => {
    updateRow(sectionIndex, rowIndex, (row) => ({
      ...row,
      stockCategory,
      stockCodeId: "",
      stockCode: "",
      stockDescription: "",
      currentStock: 0,
      stockOptions: [],
    }));

    if (!stockCategory) return;

    try {
      const response = await getStockCodesByCategory(stockCategory);
      const { data, status } = response;
      const stockOptions =
        status.code === 200 && Array.isArray(data) ? mapStockOptions(data) : [];

      updateRow(sectionIndex, rowIndex, (row) => ({
        ...row,
        stockOptions,
      }));
    } catch (error: any) {
      console.error(error);
      CustomMessage(error?.message || "Failed to fetch stock codes", "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleSelectStockChange = (
    stockCodeId: string,
    sIdx: number,
    rIdx: number
  ) => {
    updateRow(sIdx, rIdx, (row) => {
      const selected = (row.stockOptions || []).find(
        (item: StockOption) => item.value === stockCodeId
      );

      return {
        ...row,
        stockCodeId,
        stockCode: selected?.name.stockCode ?? "",
        stockDescription: selected?.name.stock_description ?? "",
        currentStock: selected?.name.currentStock ?? 0,
      };
    });
  };

  const handleSelectAssetLocalChange = (
    selectedAssetName: string,
    sIdx: number,
    rIdx: number
  ) => {
    updateRow(sIdx, rIdx, (row) => {
      const selected = (row.availableAssets || []).find(
        (item: AssetLocalOption) => item.assetName === selectedAssetName
      );

      return {
        ...row,
        assetName: selected?.assetName ?? "",
        description: selected?.localCode ?? "",
      };
    });
  };


  const defaultHeaders = [
    'Family',
    'Asset Number',
    'Description',
    'Supplier',
    'Spec / Comment',
    'Qty',
    'Date Reqd',
    'Actions'
  ];

  const renderTableHeaders = (sectionTitle: string) => {
    let headers = [...defaultHeaders];

    // 🔹 Stage is assumed as 2
    headers = headers.filter(h => h !== 'Actions'); // remove Actions temporarily

    if (['Stores Consumables', 'General Consumables'].includes(sectionTitle)) {
      headers = [
        ...headers,
        'Issued',
        'Pending',
        'Current Stock',
        'Actions'
      ];
    } else {
      headers = [
        ...headers,
        'Issued',
        'Pending',
        'Actions'
      ];
    }

    return headers.map((header, idx) => {
      // 🔹 For Consumables sections, rename specific columns
      if (['Stores Consumables', 'General Consumables'].includes(sectionTitle)) {
        if (header === 'Family') header = 'Category';
        if (header === 'Asset Number') header = 'Stock Code';
        if (header === 'Description') header = 'Stock Description';
      }

      return (
        <th key={idx} style={{ border: '1px solid #ddd', padding: '8px' }}>
          {header}
        </th>
      );
    });
  };

  return (

    <div className="p-6">
      <h2 style={{ fontSize: '18px', marginLeft: '8px', marginBottom: '50px', marginTop: '10px' }}>Stage 3</h2>
      <Container maxWidth="lg">
        <Paper>

          <Grid container spacing={3} justifyContent="center">

            <Grid item xs={12} sm={4}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    value="User Name:"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "& input.Mui-disabled": {
                          fontWeight: "bold",
                          fontSize: "16px",
                          WebkitTextFillColor: "#000", // text color for disabled
                          opacity: 1,                  // ensures full visibility
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>

                  <FormControl fullWidth variant="outlined" margin="normal">
                    <TextField

                      value={formData.username}
                      InputProps={{
                        readOnly: true,
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                        },
                      }}
                    />
                  </FormControl>

                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    value="Request From:"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "& input.Mui-disabled": {
                          fontWeight: "bold",
                          fontSize: "16px",
                          WebkitTextFillColor: "#000", // text color for disabled
                          opacity: 1,                  // ensures full visibility
                        },
                      },
                    }}

                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth variant="outlined" margin="normal">


                    <Autocomplete
                      aria-placeholder="Select a Project"
                      // className="bg-white"
                      id="project"
                      value={{
                        label: formData.requestFrom ?? "",
                        value: formData.requestFromId?.toString() ?? "",
                      }}
                      options={project}
                      getOptionLabel={(option) => option.label}
                      onChange={(event, newValue) =>
                        handleSelectProjectChange(
                          { target: { value: newValue } },
                          "requestFrom",
                          "requestFromId"
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          //  className="bg-white"
                          variant="outlined" // 👈 This gives the box style
                          label=""
                          placeholder="Select a project"
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    value="Country:"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "& input.Mui-disabled": {
                          fontWeight: "bold",
                          fontSize: "16px",
                          WebkitTextFillColor: "#000", // text color for disabled
                          opacity: 1,                  // ensures full visibility
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth variant="outlined" margin="normal">

                    <Autocomplete
                      aria-placeholder="from Country"
                      // className="bg-white"
                      id="countryName"
                      value={
                        fromCountryName.find(
                          (option) => option.value === formData.currentLocationId?.toString()
                        ) || null
                      }
                      options={fromCountryName}
                      getOptionLabel={(option) => option.label}
                      onChange={(event, newValue) =>
                        handleSelectFromCountryChange(event, newValue)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label=""
                          placeholder="from Country"
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    value="Notify:"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "& input.Mui-disabled": {
                          fontWeight: "bold",
                          fontSize: "16px",
                          WebkitTextFillColor: "#000", // text color for disabled
                          opacity: 1,                  // ensures full visibility
                        },
                      },
                    }}

                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth variant="outlined" margin="normal">
                    <Autocomplete
                      multiple
                      disableCloseOnSelect
                      //  className="bg-white"
                      id="user-multiselect"
                      value={users.filter((option) =>
                        formData.userIds.includes(option.value)
                      )}
                      options={users}
                      getOptionLabel={(option) => option.label}
                      onChange={(event, newValue) => handleSelectFromUserChange(event, newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label=""
                          placeholder="Select Users"
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    value="Address:"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "& input.Mui-disabled": {
                          fontWeight: "bold",
                          fontSize: "16px",
                          WebkitTextFillColor: "#000", // text color for disabled
                          opacity: 1,                  // ensures full visibility
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1,
                        "& fieldset": {
                          borderColor: "none",
                        },
                        "&:hover fieldset": {
                          borderColor: "none",
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    value="Google Map Location:"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "& input.Mui-disabled": {
                          fontWeight: "bold",
                          fontSize: "16px",
                          WebkitTextFillColor: "#000", // text color for disabled
                          opacity: 1,                  // ensures full visibility
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    name="mapLocation"
                    value={formData.mapLocation}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1,
                        "& fieldset": {
                          borderColor: "none",
                        },
                        "&:hover fieldset": {
                          borderColor: "none",
                        },
                      },
                    }}

                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    value="Date:"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "& input.Mui-disabled": {
                          fontWeight: "bold",
                          fontSize: "16px",
                          WebkitTextFillColor: "#000", // text color for disabled
                          opacity: 1,                  // ensures full visibility
                        },
                      },
                    }}

                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    name="date"
                    // label="Date"
                    type="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1,
                        "& fieldset": {
                          borderColor: "none",
                        },
                        "&:hover fieldset": {
                          borderColor: "none",
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    value="Notes:"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "& input.Mui-disabled": {
                          fontWeight: "bold",
                          fontSize: "16px",
                          WebkitTextFillColor: "#000", // text color for disabled
                          opacity: 1,                  // ensures full visibility
                        },
                      },
                    }}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>

                  <TextareaAutosize
                    minRows={3}
                    placeholder="Write your notes here..."
                    value={formData.notes || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, notes: e.target.value })
                    }
                    style={{
                      width: "215%",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      padding: "10px",
                      fontFamily: "inherit",
                      fontSize: "14px",
                      resize: "vertical", // expandable like comments
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    value="Indent No:"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "& input.Mui-disabled": {
                          fontWeight: "bold",
                          fontSize: "16px",
                          WebkitTextFillColor: "#000", // text color for disabled
                          opacity: 1,                  // ensures full visibility
                        },
                      },
                    }}

                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    name="indentNo"
                    value={formData.indentNo}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1,
                        "& fieldset": {
                          borderColor: "none",
                        },
                        "&:hover fieldset": {
                          borderColor: "none",
                        },
                      },
                    }}

                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    value="Request To:"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "& input.Mui-disabled": {
                          fontWeight: "bold",
                          fontSize: "16px",
                          WebkitTextFillColor: "#000", // text color for disabled
                          opacity: 1,                  // ensures full visibility
                        },
                      },
                    }}

                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth variant="outlined" margin="normal">
                    <Autocomplete
                      aria-placeholder="Select a Project"
                      //  className="bg-white"
                      id="project"
                      value={{
                        label: formData.requestTo ?? "",
                        value: formData.requestToId?.toString() ?? "",
                      }}
                      options={requestproject}
                      getOptionLabel={(option) => option.label}
                      onChange={(event, newValue) =>
                        handleSelectProjectChange(
                          { target: { value: newValue } },
                          "requestTo",
                          "requestToId"
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // className="bg-white"
                          variant="outlined" // 👈 This gives the box style
                          label=""
                          placeholder="Select a project"
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                        "& input.Mui-disabled": {
                          fontWeight: "bold",
                          fontSize: "16px",
                          WebkitTextFillColor: "#000", // text color for disabled
                          opacity: 1,                  // ensures full visibility
                        },
                      },
                    }}
                    value="Default List"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth variant="outlined" margin="normal">
                    <Autocomplete
                      value={defaultLists.find((opt) => opt.label === formData.indentTemplateName) || null}
                      options={defaultLists}
                      getOptionLabel={(option) => option.label}
                      onChange={handleTemplateSelect}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label=""
                          placeholder="Select Template"
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.value === value?.value}
                    />

                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        <div
          style={{
            backgroundColor: "#fff3e0",
            padding: "20px",
            borderRadius: "8px",
            marginTop: "20px",
          }}
        >

          {/* <div
              style={{
                fontSize: "14px",
                color: "#555",
                marginBottom: "20px",
              }}
            >
              Home &gt; Asset Request &gt;{" "}
              <span style={{ color: "#1976d2" }}>New Entry</span>
            </div>             */}
          <div>
            {data.map((section, sIdx) => (
              <div
                key={sIdx}
                ref={(el) => (sectionRefs.current[sIdx] = el)}
                style={{
                  border: "1px solid #ccc",
                  marginBottom: "15px",
                  borderRadius: "8px",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                }}
              >
                <details
                  open={sIdx === 0} // optional: keep first one open by default
                  onClick={() => setSelectedSectionIdx(sIdx)}
                >
                  <summary
                    style={{
                      padding: '12px 16px',
                      fontSize: '18px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                    }}
                  >
                    {section.title}
                  </summary>
                  <div style={{ padding: '16px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ height: '50px', backgroundColor: '#f5f5f5' }}>
                          {renderTableHeaders(section.title)}
                        </tr>
                      </thead>
                      <tbody>
                        {section.rows.map((row, rIdx) => (
                          <tr
                            key={rIdx}
                            style={{
                              height: "50px",
                              backgroundColor: row.pending > 0 ? "#e10417ff" : "#f5f5f5", // 🔴 Red if pending > 0, else default gray
                            }}
                          >
                            {["Stores Consumables", "General Consumables"].includes(section.title) ? (
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                <Autocomplete
                                  size="small"
                                  sx={tableAutocompleteSx}
                                  options={categories}
                                  value={row.stockCategory ? categories.find((cat) => cat.value === row.stockCategory) || null : null}
                                  getOptionLabel={(option) => option.label}
                                  isOptionEqualToValue={(option, value) => option.value === value.value}
                                  onChange={(_, newValue) => onFetchData(newValue?.value ?? "", sIdx, rIdx)}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label=""
                                      placeholder={row.stockCategory ? "" : "Select Category"}
                                      size="small"
                                      fullWidth
                                      InputLabelProps={{ shrink: false }}
                                    />
                                  )}
                                />
                              </td>
                            ) : (

                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>

                                {/* <select
                                  value={row.familyAssetId ?? ''} // Fallback to an empty string if familyAssetId is null
                                  onChange={(e) => handleSelectFamilyChange(sIdx, rIdx, e.target.selectedIndex)}
                                  style={{ width: '100%', height: '35px' }}
                                >
                                  {families.map((fam, i) => (
                                    <option key={i} value={fam.value as string || ''}>
                                    {fam.label}
                                  </option>
                                  
                                  ))}
                                </select> */}


                                <Autocomplete
                                  size="small"
                                  sx={tableAutocompleteSx}
                                  options={
                                    section.title === 'Main (internal)' ? internalfamilies :
                                      section.title === 'Main (external)' ? externalfamilies :
                                        section.title === 'Tools (internal)' ? toolsfamilies :
                                          families
                                  }
                                  value={Number(row.familyAssetId) > 0 ? (
                                    section.title === 'Main (internal)' ? internalfamilies :
                                      section.title === 'Main (external)' ? externalfamilies :
                                        section.title === 'Tools (internal)' ? toolsfamilies :
                                          families
                                  ).find((fam) => Number(fam.value) === Number(row.familyAssetId)) || null : null}
                                  getOptionLabel={(option) => option.label}
                                  isOptionEqualToValue={(option, value) => option.value === value.value}
                                  onChange={(_, newValue) => {
                                    if (newValue?.value) {
                                      handleSelectFamilyChange(sIdx, rIdx, newValue.value, section.title);
                                    } else {
                                      updateRow(sIdx, rIdx, (currentRow) => ({
                                        ...currentRow,
                                        familyAssetId: 0,
                                        familyName: "",
                                        assetName: "",
                                        description: "",
                                        availableAssets: [],
                                      }));
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label=""
                                      placeholder={Number(row.familyAssetId) > 0 ? "" : "Select Family"}
                                      size="small"
                                      fullWidth
                                      InputLabelProps={{ shrink: false }}
                                    />
                                  )}
                                />

                              </td>
                            )}
                            {['Stores Consumables', 'General Consumables'].includes(section.title) ? (
                              <>
                                {/* 🔹 Stock Code Dropdown */}
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                  <Autocomplete
                                    size="small"
                                    sx={tableAutocompleteSx}
                                    options={row.stockOptions || []}
                                    value={row.stockCodeId ? (row.stockOptions || []).find((item: StockOption) => item.value === row.stockCodeId) || null : null}
                                    getOptionLabel={(option: StockOption) => option.name.stockCode}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    onChange={(_, newValue) => handleSelectStockChange(newValue?.value ?? "", sIdx, rIdx)}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label=""
                                        placeholder={row.stockCodeId ? "" : "Select Stock Code"}
                                        size="small"
                                        fullWidth
                                        InputLabelProps={{ shrink: false }}
                                      />
                                    )}
                                  />
                                </td>

                                {/* 🔹 Stock Description (disabled, auto-filled) */}
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                  <Autocomplete
                                    size="small"
                                    sx={tableAutocompleteSx}
                                    options={row.stockOptions || []}
                                    value={row.stockCodeId ? (row.stockOptions || []).find((item: StockOption) => item.value === row.stockCodeId) || null : null}
                                    getOptionLabel={(option: StockOption) => option.name.stock_description}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    onChange={(_, newValue) => handleSelectStockChange(newValue?.value ?? "", sIdx, rIdx)}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label=""
                                        placeholder={row.stockCodeId ? "" : "Select Stock Description"}
                                        size="small"
                                        fullWidth
                                        InputLabelProps={{ shrink: false }}
                                      />
                                    )}
                                  />
                                </td>
                              </>
                            ) : (
                              <>
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                  <Autocomplete
                                    size="small"
                                    sx={tableAutocompleteSx}
                                    options={row.availableAssets || []}
                                    value={row.assetName || row.description ? (row.availableAssets || []).find((a: AssetLocalOption) => a.assetName === row.assetName || a.localCode === row.description) || null : null}
                                    getOptionLabel={(option: AssetLocalOption) => option.assetName}
                                    isOptionEqualToValue={(option, value) => option.assetName === value.assetName}
                                    onChange={(_, newValue) => handleSelectAssetLocalChange(newValue?.assetName ?? "", sIdx, rIdx)}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label=""
                                        placeholder={row.assetName || row.description ? "" : "Select Asset Name"}
                                        size="small"
                                        fullWidth
                                        InputLabelProps={{ shrink: false }}
                                      />
                                    )}
                                  />

                                </td>

                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                  <Autocomplete
                                    size="small"
                                    sx={tableAutocompleteSx}
                                    options={row.availableAssets || []}
                                    value={row.assetName || row.description ? (row.availableAssets || []).find((a: AssetLocalOption) => a.assetName === row.assetName || a.localCode === row.description) || null : null}
                                    getOptionLabel={(option: AssetLocalOption) => option.localCode}
                                    isOptionEqualToValue={(option, value) => option.assetName === value.assetName}
                                    onChange={(_, newValue) => handleSelectAssetLocalChange(newValue?.assetName ?? "", sIdx, rIdx)}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label=""
                                        placeholder={row.assetName || row.description ? "" : "Select Asset Description"}
                                        size="small"
                                        fullWidth
                                        InputLabelProps={{ shrink: false }}
                                      />
                                    )}
                                  />
                                </td>
                              </>
                            )}
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                              <Autocomplete
                                size="small"
                                sx={tableAutocompleteSx}
                                options={suppliers}
                                value={Number(row.localStoreId) > 0 ? suppliers.find((sup) => String(sup.value ?? "") === String(row.localStoreId ?? "")) || null : null}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                onChange={(_, newValue) => {
                                  if (newValue) {
                                    const selectedIndex = suppliers.findIndex((sup) => sup.value === newValue.value);
                                    if (selectedIndex >= 0) handleLocalStoreChange(sIdx, rIdx, selectedIndex);
                                  } else {
                                    handleChange(sIdx, rIdx, "localStore", "");
                                    handleChange(sIdx, rIdx, "localStoreId", 0);
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label=""
                                    placeholder={Number(row.localStoreId) > 0 ? "" : "Select Local Store"}
                                    size="small"
                                    fullWidth
                                    InputLabelProps={{ shrink: false }}
                                  />
                                )}
                              />
                            </td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                              <input
                                type="text"
                                value={row.comment}
                                onChange={(e) => handleChange(sIdx, rIdx, 'comment', e.target.value)}
                                style={{ width: '100%', height: '35px' }}
                              />
                            </td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                              <input
                                type="number"
                                value={row.qty === 0 ? "" : row.qty} // Show empty if 0
                                onChange={(e) =>
                                  handleChange(
                                    sIdx,
                                    rIdx,
                                    'qty',
                                    e.target.value === "" ? 0 : parseInt(e.target.value)
                                  )
                                }
                                style={{ width: '100%', height: '35px' }}
                              />
                            </td>

                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                              <input
                                type="date"
                                value={row.dateReqd ? new Date(row.dateReqd).toISOString().split('T')[0] : ''}
                                onChange={(e) =>
                                  handleChange(sIdx, rIdx, 'dateReqd', e.target.value === "" ? 0 : parseInt(e.target.value))

                                }
                                style={{ width: '100%', height: '35px' }}
                              />
                            </td>
                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                              <input
                                type="number"
                                value={row.issued === 0 ? "" : row.issued}
                                onChange={(e) =>
                                  handleChange(
                                    sIdx,
                                    rIdx,
                                    "issued",
                                    e.target.value === "" ? 0 : parseInt(e.target.value)
                                  )
                                }
                                style={{ width: "100%", height: "35px" }}
                              />
                            </td>


                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                              <input
                                type="number"
                                value={row.pending === 0 ? "" : row.pending}
                                onChange={(e) =>
                                  handleChange(
                                    sIdx,
                                    rIdx,
                                    "pending",
                                    e.target.value === "" ? 0 : parseInt(e.target.value)
                                  )
                                }
                                style={{ width: "100%", height: "35px" }}
                              />

                            </td>

                            {['Stores Consumables', 'General Consumables'].includes(section.title) && (
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                <input
                                  type="number"
                                  value={row.currentStock ?? ""}
                                  readOnly
                                  style={{ width: "100%", height: "35px" }}
                                />
                              </td>
                            )}


                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                              <button
                                onClick={() => handleDeleteRow(sIdx, rIdx)}
                                style={{
                                  backgroundColor: 'transparent',
                                  border: 'none',
                                  color: '#e74c3c',
                                  fontSize: '20px',
                                  cursor: 'pointer',
                                }}
                                title="Delete row"
                              >
                                ✖️
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <div style={{ textAlign: 'center', marginTop: '15px' }}>
                      <button
                        onClick={() => handleAddRow(sIdx)}
                        style={{
                          width: '100px',
                          height: '30px',
                          backgroundColor: '#1976d2',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                        }}
                      >
                        Add New
                      </button>
                    </div>

                  </div>
                </details>
              </div>

            ))}
          </div>

          <div style={{ marginTop: "20px", textAlign: "center" }}>
            {formData.status !== 1 &&
              userDetails.role.some(
                (r) => r.roleName === "Admin" || r.roleName === "Indents Write"
              ) && (

                <>
                  <button
                    onClick={() => handleSubmit(1, 3)} // Submit with status = 1
                    style={{
                      padding: '10px 20px', // top-bottom, left-right
                      backgroundColor: '#2ecc71',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      fontSize: '16px',
                      cursor: 'pointer',
                      marginRight: '20px',
                      lineHeight: '1.2',
                      whiteSpace: 'nowrap', // Optional: prevents text from wrapping
                    }}
                  >
                    Submit to next stage
                  </button>

                  <button
                    onClick={() => handleSubmit(0, 3)} // Save Draft with status = 0
                    style={{
                      width: '100px',
                      height: '40px',
                      backgroundColor: '#3498db',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '4px',
                      fontSize: '18px',
                      cursor: 'pointer',
                      marginRight: '20px',
                    }}
                  >
                    Save Draft
                  </button>
                </>

              )}


            <button
              onClick={() => handleCancel()}
              style={{
                width: '100px',
                height: '40px',
                backgroundColor: '#e74c3c',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                fontSize: '18px',
                cursor: 'pointer',
              }}
            >
              Cancel
            </button>


          </div>



        </div>






      </Container>
    </div>

  );
};

export default CreatingIndentStageThree;

